/*
EventForm Component
*/
import React, {Component} from 'react';
import { Button, ModalBody, ModalFooter} from 'reactstrap';
import {globals} from '../Globals/Globals'
import Editor from '../Editor/Editor';
import DatePicker, { registerLocale, setDefaultLocale }  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MediaUpload from '../MediaUpload/MediaUpload';
import TimePickerPackage from "../TimePickerPackage/TimePickerPackage"

class EventForm extends Component{
    constructor(props){
        super(props);

        this.clearObject={
            hour:null,
            minutes:null,
            date:new Date(),
            day:0,
            month:0,
            year:0,
            did_not_change : true,
            media_filename:"",
            title:"",
            text:"",
            is_podcast:false,
            formErrors: {
                date:'',
                media_filename:'', title:'', 
                hour:'',
                minutes:'',
                text:'', 
                is_podcast:"",
                },
            is_podcasttext:`Il s'agit d'une vidéo`,
            idpartner:-1,
            offers:[],
            gallery:[]
        }

        this.state = this.clearObject;
        this.ispodcastCheckBoxRef = React.createRef();
    }

    clearForm = () => {
        this.clearObject = Object.assign(this.clearObject, this.props.data)
        if (this.props.data){
            let provided_date = {day:this.props.data.day, month:this.props.data.month, year:this.props.data.year}
            if (globals.parameters.debugging){
                console.log("provided_date =>", provided_date)
            }
            let l_o_convertedDate = this.convertDate(provided_date);
            this.clearObject.date = l_o_convertedDate.asString

            this.clearObject.day = l_o_convertedDate.asDate.day;
            this.clearObject.month = l_o_convertedDate.asDate.month;
            this.clearObject.year = l_o_convertedDate.asDate.year;
        }
        this.setState(this.clearObject, ()=>{console.clear(); console.log("setState => ", this.state)});
    }

    onFormSubmitHandler = async event => {
        event.preventDefault();
        let canSubmit = this.onCheckFormValidationBeforeSubmit();

        if (globals.parameters.debugging){
            console.log("canSubmit:", canSubmit)
        }

        if (!canSubmit) return;//Cancel submit

        //Call micro-service
        if (globals.parameters.debugging){
            console.log(`onFormSubmitHandler::JSON.stringify(this.state) => ${JSON.stringify(this.state)}`)
            console.log("onFormSubmitHandler::micro-service => this.partner_service:", globals.services.event_create,"state size", Math.floor(JSON.stringify(this.state).length),"Mo state =>", this.state);
        }

        var serviceResult = null
        try{
            await fetch(
                    `${globals.services.event_create}`,{
                        headers: {
                                    'Content-Type': 'application/json'},
                                    //'Content-Type': 'application/x-www-form-urlencoded'},
                        method: "POST", 
                        body: JSON.stringify(this.state)}).then(
                results => {return results.text();}
                ).then(
                  (server_response) =>{
                    if (globals.parameters.debugging)
                        console.log("sever_response =>", server_response)

                    serviceResult = JSON.parse(server_response);
                    //------------------------------------------ Asynchronous promise result handle
                    //Get service aknowledge before resetting state values.
                    console.log("client_create_event_log => returns : ", serviceResult);

                    if (serviceResult.state === true) {
                        //
                        alert("Evènement créé !")

                        //Clear form
                        if (!globals.parameters.debugging)
                            this.clearForm();

                        //Trigger on terminate
                        if (this.props.onTerminate){
                            this.props.onTerminate()
                        }                                                    
                    }
                    else{
                        alert("Erreur:" + serviceResult.message);
                    }
                    //--------------------------------------- End of promise Accept
                  } 
                )
        } catch(err){
            alert(`Verifiez votre connexion wifi : ${err}`);
            return;
        }
    }  

    onFormUpdateHandler = async event => {
        event.preventDefault();

        if (!this.onCheckFormValidationBeforeSubmit()) return;//Cancel submitt

        //Call micro-service
        if (globals.parameters.debugging){
            console.log(`onFormUpdateHandler::JSON.stringify(this.state) => ${JSON.stringify(this.state)}`)
            console.log("onFormUpdateHandler::micro-service => this.partner_service:", globals.services.event_update,"state size", Math.floor(JSON.stringify(this.state).length),"Mo state =>", this.state);
        }

        var serviceResult = null
        try{
            await fetch(
                    `${globals.services.event_update}`,{
                        headers: {
                                    'Content-Type': 'application/json'},
                                    //'Content-Type': 'application/x-www-form-urlencoded'},
                        method: "POST", 
                        body: JSON.stringify(this.state)}).then(
                results => {return results.text();}
                ).then(
                  (server_response) =>{
                    if (globals.parameters.debugging)
                        console.log("sever_response =>", server_response)

                    serviceResult = JSON.parse(server_response);
                    //------------------------------------------ Asynchronous promise result handle
                    //Get service aknowledge before resetting state values.
                    console.log("client_update_event_log => returns : ", serviceResult);

                    if (serviceResult.state === true) {
                        //
                        alert("Evènement modifié !")

                        //Clear form
                        if (!globals.parameters.debugging)
                            this.clearForm();

                        //Return to table mode
                        //Trigger on terminate
                        if (this.props.onTerminate){
                            this.props.onTerminate()
                        }                            
                    }
                    else{
                        alert("Erreur:" + serviceResult.message);
                    }
                    //--------------------------------------- End of promise Accept
                  } 
                )
        } catch(err){
            alert(`Verifiez votre connexion wifi : ${err}`);
            return;
        }
    }  

    componentDidMount = () =>{
        this.handle_media_filename = this.handle_media_filename.bind(this);
        this.handle_title = this.handle_title.bind(this);   
        this.handle_text = this.handle_text.bind(this);
        this.handle_text_rich_edit = this.handle_text_rich_edit.bind(this);

        //First component initialization
        if (globals.parameters.debugging){
            this.setState(
                {   
                    date:"10/07/2022",
                    day:10,
                    month:7,
                    year:2022,
                    media_filename:null, 
                    title:"Prédication de Patrick",                 
                    text:"Ayez du sel en vous",
                    
                    did_not_change:true, 
                    is_podcast:true,
                    
                });
        }

        //Component initialization in edit mode
        if (this.props.data){
            this.clearForm();
        }
    }

    validateField = (value) => {
        let fieldValidationErrors = this.state.formErrors;
        let dateValid = this.state.dateValid;
      
        //dateValid = value.match(/^(0|(\\+33)|(0033))[1-9][0-9]{8}$/i);
        dateValid = (value != "");
        fieldValidationErrors.date = dateValid ? '' : ' est invalide';
  
        this.setState({formErrors: fieldValidationErrors,
                        dateValid: dateValid
                      }, this.validateForm);
    }

    convertDate = (p_o_day_month_year) => {
        function pad(s) { return (s < 10) ? '0' + s : s; }

        return {
                asString:[pad(p_o_day_month_year.day), pad(p_o_day_month_year.month), p_o_day_month_year.year].join('/'), 
                asDate:{
                    day: p_o_day_month_year.day,
                    month:p_o_day_month_year.month,
                    year: p_o_day_month_year.year
                },
            }
    }
    
    handle_date_picker = (p_oDate) => {
        //Convert date picker string as day month year object
        let dateConvertedObject = this.convertDate({day:p_oDate.getDate(), month: 1 + p_oDate.getMonth(), year:p_oDate.getFullYear()})
        console.log("p_oDate =>", p_oDate)
        console.log("dateConvertedObject =>", dateConvertedObject)
        //Update date value from form field
        this.setState(
            {
            did_not_change:false, 
            date:dateConvertedObject.asString,
            month:dateConvertedObject.asDate.month, 
            day: dateConvertedObject.asDate.day,
            year: dateConvertedObject.asDate.year,
            //obsolete date_raw:pDateString //Date as raw string
            }, () => {this.validateField(dateConvertedObject.asString); console.log(`day:${this.state.day} / month:${this.state.month} / year:${this.state.year}`)});
    }

    handle_title = (e) => {
        e.preventDefault();
        //Update title value from form field
        this.setState({did_not_change:false, title:e.target.value}, () => {this.checkValidation(e.target.name);});
    }

    

    handle_text = (e) => {
        e.preventDefault();
        //Update text value from form field
        this.setState({did_not_change:false, text:e.target.value}, () => {this.checkValidation(e.target.name);});
    }

    handle_text_rich_edit = (new_rich_edit) => {
        //Update text value from form field
        this.setState({did_not_change:false, text:new_rich_edit}, () => {this.checkValidation("text");});
    }

    handle_media_filename = (UploadFile) => {
        this.setState(
            {did_not_change:false, 
              media_filename: UploadFile ? UploadFile.name : ""},
               ()=>{
                  console.log("handle_media_filename::this.state:", this.state);
                  if (UploadFile) {
                    console.log("UploadFile =>", UploadFile)
                    alert(`Let us copy ${UploadFile.name} file on remote server...`);
                  }
                });
    }

    onChangeCheckboxIsPodcast = (e) => {
        this.setState({is_podcast:e.target.checked?1:0}, ()=>{if(globals.parameters.debugging) console.log("checkvalidation not required for IsPodcast")});
    } 
    
    onClickCheckboxIsPodcast = (e) => {
        e.preventDefault()
        this.setState(
            {rgis_podcastpd:!this.ispodcastCheckBoxRef.current.checked?1:0}, 
            ()=>{if(globals.parameters.debugging) console.log("checkvalidation not required for IsPodcast")});
    }


    //Validation methods
    errorClass = (error) => {
        return(error.length === 0 ? '' : 'has-error');
    }

    checkValidation = (fieldName) => {
        let value = null;
        try{
            value = this.state[fieldName];
        }
        catch(e){
            alert(`Field '${fieldName}' not found`)
        }
        
        if (globals.parameters.debugging)
            console.log("fieldName:", fieldName, " value:", value)

        let fieldValidationErrors = this.state.formErrors;

        switch(fieldName) {
            case 'date':
                console.log("date checked ->", value)
                fieldValidationErrors.date = (value.length > 1) ? '' : ' est obligatoire';
                break;

            case 'media_filename':
                /*fieldValidationErrors.media_filename = (value.length > 0) ? '' : ' est obligatoire';*/
                break;

            case 'title':
                fieldValidationErrors.title = (value.length > 1) ? '' : ' est obligatoire';
                break;

            
            case 'text':
                fieldValidationErrors.text = (value.length > "<p><br></p>".length)? '' : ' est trop court';
                break;

            case 'hour':
                fieldValidationErrors.hour = (this.state.hour) ? "" : "L'heure est obligatoire";
                break;

            case 'minutes':
                fieldValidationErrors.minutes = (this.state.minutes) ? "" : "Les minutes sont obligatoires"
                break;

            default:
                alert(`checkValidation field' ${fieldName}' not found !`)
                break;
        }

        if (globals.parameters.debugging){
            console.log(`-----------------`)
            console.log(`fieldName => ${fieldName}`)
            console.log(`value => ${value}`)
            console.log(`fieldValidationErrors => ${fieldValidationErrors}`)
            console.log(`fieldValidationErrors.join('') => ${Object.values(fieldValidationErrors).join("/")}`)
            console.log(`fieldValidationErrors.join('').length => ${Object.values(fieldValidationErrors).join("").length}`)
            /*
            console.log(`errorsFieldName => ${errorsFieldName}`)
            console.log(`nextErrors => ${nextErrors}`)
            console.log(`nextErrors.length => ${nextErrors.length}`)*/
        }

        //update internal state
        //this.setState({formErrors: fieldValidationErrors}, () => {if (globals.parameters.debugging) console.log("formErrors =", this.state.formErrors)});
        this.setState({formErrors: fieldValidationErrors});

        return (Object.values(fieldValidationErrors).join("").length === 0);
    }

    onCheckFormValidationBeforeSubmit = () => {
        //Force all fields check
        try{
            //let canSubmit = this.checkValidation('media_filename')
            let canSubmit = this.checkValidation('date')
            canSubmit &= this.checkValidation('title')          
            canSubmit &= this.checkValidation('text')
            
            canSubmit &= this.checkValidation('hour')
            canSubmit &= this.checkValidation('minutes');

            return (canSubmit);
        }
        catch(e){
            return false;
        }
    }

    render = () => {
        return(
            <div id="partner-form-container">
                {globals.parameters.debugging && <h1>DEBUGGING MODE</h1>}
                <ModalBody>
                <form id="requete-form" onSubmit={this.props.data?this.onFormUpdateHandler:this.onFormSubmitHandler}> 

                {this.props.data && <h2>Modifier un évènement</h2>}
                {!this.props.data && <h2>Créer un nouvel évènement</h2>}
                <div className={`form-group`}/>
                    <div className="form-group row">
                        <div className="col-md-6">
                            <label className="col-md-12 col-form-label">Date:</label>
                            <div className="col-md-10">
                                <DatePicker 
                                locale="fr"
                                value ={this.state.date} 
                                placeholder="dd-mm-yyyy"
                                onChange={(p_oDate) => {this.handle_date_picker(p_oDate)}} />
                                {/* Sticky error label */}
                                <label
                                    className="form-error">
                                    {this.state.formErrors.date}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="col-md-10">
                                <TimePickerPackage
                                    hour_title = {"heure"}
                                    hour_placeholder = {"heure"}
                                    minutes_title = {"minutes"}
                                    minutes_placeholder = {"minutes"}
                                    required = {false}
                                    onChange={(timeValuePack) => {console.log("valuepack in EventForm ==>", timeValuePack);this.setState({hour:timeValuePack.hour, minutes:timeValuePack.minutes})}}
                                />
                                {/* Sticky error label */}
                                <label
                                    className="form-error">
                                    {this.state.formErrors.hour}
                                    {this.state.formErrors.minutes}
                                </label>
                            </div>
                        </div>

                        {/** Unused
                        <div className="col-md-12">
                            <label className="col-md-12 col-form-label">Contient un fichier</label>
                            <div className="col-md-12">
                                <input 
                                    className='pointer'
                                    ref={this.ispodcastCheckBoxRef}
                                    id="ispodcast" 
                                    type="checkbox" 
                                    checked={this.state.is_podcast===1?true:false} 
                                    onChange={(e)=>{this.onChangeCheckboxIsPodcast(e)}}/>
                                    
                                 <label 
                                    className="form-error">
                                    {this.state.formErrors.is_podcast} 
                                </label>
                            </div>
                        </div>*/}

                        <div className="col-md-4">
                            <label className="col-md-12 col-form-label">Titre:</label>
                            <div className="col-md-10">
                                <input name="title" className="form-control" value={this.state.title} onChange={(e)=>{this.handle_title(e);}} type="text" placeholder="Titre de l'évènement"/>

                                {/* Sticky error label */}
                                <label 
                                    className="form-error">
                                    {this.state.formErrors.title} 
                                </label>                            
                            </div>

                        </div>

                        <div className="col-md-4">
                            <label className="col-md-12 col-form-label">Média (Audio ou Vidéo):</label>
                            <div className="col-md-10">
                                <MediaUpload
                                    data={this.state.media_filename} 
                                    uploadMedia={this.handle_media_filename} 
                                />

                                {/* Sticky error label */}
                                <label 
                                    className="form-error">
                                    {this.state.formErrors.media_filename} 
                                </label>
                            </div>
                        </div>


                        
                    </div>

                    <div className="form-group row">
                        <div className="col-md-8">
                            <label className="col-md-12 col-form-label">Description activite:</label>
                            <div className="col-md-12 editor-container">

                                {!globals.parameters.rich_edit_enabled &&
                                <textarea name="text" className="form-control" value={this.state.text} onChange={(e)=>{this.handle_text(e);}} type="text" placeholder="Décrivez votre activité"/>}
                                
                                {/* Sticky error label */}
                                <label 
                                    className="form-error">
                                    {this.state.formErrors.text} 
                                </label>
                                {globals.parameters.rich_edit_enabled &&
                                <Editor
                                    value={this.state.text}
                                    onChange={(value) => {this.handle_text_rich_edit(value)}}
                                    readOnly={false}
                                    style={{ height: "150px", margin: "0em", flex: "1" }}
                                />}
                            </div>
                        </div>

                        
                    </div>
                    
                </form>
                </ModalBody>
                <ModalFooter>
                    {globals.parameters.debugging && <h1>DEBUGGING MODE</h1>}

                    <Button 
                        color="primary" 
                        form="requete-form" 
                        >{this.props.data?"Enregistrer les modifications":"Enregistrer"}</Button>

                    <Button 
                        color="secondary" 
                        onClick={(e) => {this.clearForm();}} 
                        hidden={this.state.did_not_change}>{this.props.data?"Annuler les modifications":"Tout effacer"}                        
                    </Button>

                    {this.props.onClose &&
                        <Button 
                            color="secondary"
                            hidden={!this.state.did_not_change} 
                            onClick={(e) => {this.props.onClose();}}>Fermer</Button>}
                </ModalFooter>
            </div>
        )
    }
}

export default EventForm;